import {
  Component,
  OnInit,
  AfterViewInit,
  Inject,
  Output,
  EventEmitter,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DbService } from '../core/services/db.service';
import { Observable } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlarmDetailComponent } from '../pages/alarm-detail/alarm-detail.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  configData;
  openSwitch = false;

  menu = [
    {
      label: '대시보드',
      icon: 'bxs-home-circle',
      link: '/dashboard',
    },
    {
      label: '회원관리',
      icon: 'bxs-user',
      link: '/user-list',
    },
    {
      label: '주차장리스트',
      icon: 'bxs-parking',
      link: '/parking-list',
    },
    {
      label: '차실리스트',
      icon: 'bxs-parking',
      link: '/parking-room-list',
    },
    {
      label: '주차장 등록/요청',
      icon: 'bxs-edit',
      subItems: [
        {
          label: '주차장등록',
          link: '/parking-regist',
        },
        {
          label: '등록 요청 리스트',
          link: '/parking-request',
        },
      ],
    },
    {
      label: '대기등록 관리',
      icon: 'bxs-user-check',
      link: '/waiting-list',
    },
    {
      label: '매출관리',
      icon: 'bxs-memory-card',

      subItems: [
        {
          label: '주차장',
          link: '/sales-parking',
        },
        {
          label: '이용고객',
          link: '/sales-user',
        },
      ],
    },
    {
      label: 'NPD보장관리',
      icon: 'bxs-smile',
      link: '/npd',
    },
    {
      label: '결제관리',
      icon: 'bxs-credit-card',
      subItems: [
        {
          label: '결제관리',
          link: '/payment-list',
        },
        {
          label: '환불관리',
          link: '/payment-refund-list',
        },
      ],
    },
    {
      label: '정산관리',
      icon: 'bxs-calculator',
      link: '/calc-list',
    },
    {
      label: '중도해지관리',
      icon: 'bxs-folder-minus',
      link: '/cancel-list',
    },
    {
      label: '관리자등록',
      icon: 'bxs-note',
      link: '/manager',
    },
    {
      label: '차량정보관리',
      icon: 'bxs-car',
      link: '/car-info-list',
    },
    {
      label: '관련서류',
      icon: 'bxs-file',
      link: '/form',
    },
    {
      label: '서비스/정보관리',
      icon: 'bxs-help-circle',
      subItems: [
        {
          label: '공지사항',
          link: '/notice-list',
        },
        {
          label: '1:1문의',
          link: '/inquire-list',
        },
        {
          label: 'FAQ',
          link: '/faq-list',
        },
        {
          label: '이용약관',
          link: '/terms-list',
        },
      ],
    },
    {
      label: '서비스관리',
      icon: 'bxl-stripe',
      subItems: [
        {
          label: '은행명관리',
          link: '/bank-list',
        },
        // {
        //   label: '광고배너관리',
        //   link: '/banner-list',
        // },
      ],
    },
    {
      label: '신고관리',
      icon: 'bxs-report',
      subItems: [
        {
          label: '주차장신고',
          link: '/report-parking',
        },
        {
          label: '후기댓글신고',
          link: '/report-review',
        },
      ],
    },
    {
      label: `Today's discount 관리`,
      icon: 'bxs-discount',
      link: '/today-discount',
    },
    {
      label: '알림관리',
      icon: 'bxs-alarm',
      link: '/push',
    },
    {
      label: '쿠폰관리',
      icon: 'bxs-coupon',
      subItems: [
        {
          label: '쿠폰관리',
          link: '/coupon',
        },
        {
          label: '쿠폰발급내역',
          link: '/coupon-list',
        },
      ],
    },
  ];

  routerUrl: string;

  constructor(
    // private eventService: EventService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private db: DbService,
    private modalService: NgbModal
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        // this._activateMenuDropdown();
        this.routerUrl = event.url;
      }
    });
  }

  ngOnInit() {
    this.getData();
    //사이드바 정의
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };
  }

  alarms$: Observable<any>;
  getData() {
    this.alarms$ = this.db.collection$('notification', (ref) =>
      ref
        .where('uid', '==', 'admin')
        .where('readSwitch', '==', false)
        .orderBy('dateCreated', 'desc')
    );
  }

  alarmDetailModal() {
    this.modalService.open(AlarmDetailComponent, {
      scrollable: false,
      centered: true,
      size: 'lg',
    });
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    localStorage.removeItem('adminInfo');
    this.router.navigate(['/account/login']);
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>('.active');
    if (activeTag) {
      activeTag.classList.remove('active');
    }
    if (list.openSwitch) {
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach((ele) => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(
              `.atag${mi}${index}`
            );
            aTag.classList.add('active');
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add('active');
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }
}
